import { green, red } from "@material-ui/core/colors";

const styles = {
  iconsRoot:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkIcon: {
    color: green[400],
  },
  closeIcon: {
    color: red[400],
  },
};

export default styles;
